import { Step } from 'signup-constants/Step';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
export const BranchACQ149 = {
  name: 'BranchACQ149',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0149, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    return dispatch(FlowStateManager.removeSteps([Step.ProblemAwareness, Step.ProductExperience], false));
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};